<template>
  <div>
    <swiper
      class="swiper"
      :class="{ 'swiper-whole': isSpecial }"
      :options="swiperOption"
      v-if="swiperArr.length > 0"
      ref="mySwiper"
    >
      <swiper-slide
        v-for="(item, index) in swiperArr"
        :key="index"
        :data-strId="item.strId"
      >
        <router-link
          target="_blank"
          class="link"
          :to="{
            path: '/detail',
            query: {
              strWebSiteId: $route.query.strWebSiteId,
              strId: item.strId,
            },
          }"
        >
          <img :data-strId="item.strId" :src="item.strPicPath" alt="" />
          <p :data-strId="item.strId">{{ item.strMasTitle }}</p>
        </router-link>
      </swiper-slide>
      <div
        class="swiper-pagination swiper-pagination-bullets"
        slot="pagination"
      ></div>
    </swiper>
    <div v-else class="no-content">暂无数据</div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.min.css";
export default {
  name: "SwiperComponents",
  components: {
    Swiper,
    SwiperSlide,
  },
  props: {
    swiperArr: {
      type: Array,
      default: () => [],
    },
    isSpecial: {
      type: Boolean,
      default: false,
    },
  },
  computed: {},
  data() {
    return {
      swiperOption: {
        loop: true,
        autoplay: {
          delay: 2500,
          disableOnInteraction: false,
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      },
    };
  },
  watch: {},
  created() {},
  mounted() {},
  methods: {
    // 跳转详情
    // detailHandle (i) {
    //   if (i.strUrlType == '_blank') {
    //     window.open(i.strUrl, i.strUrlType)
    //   } else {
    //     let routeData = this.$router.resolve({
    //       path: '/detail',
    //       query: { strWebSiteId: this.$route.query.strWebSiteId, strId: i.strId }
    //     })
    //     window.open(routeData.href, '_blank')
    //   }
    // }
  },
};
</script>

<style scoped  lang="less">
.no-content {
  width: 600px;
  height: 400px;
  border: 1px solid #eee;
  box-sizing: border-box;
  box-sizing: border-box;
  font-size: 18px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}
.swiper {
  width: 600px;
  height: 360px;
  box-sizing: border-box;
  border: 1px solid #eee;
  border-radius: 10px;
  .swiper-slide {
    display: flex;
    justify-content: center;
    align-items: center;
    background-size: cover;
    overflow: hidden;
    img {
      display: block;
      width: 100%;
      height: 100%;
      margin: 0 auto;
    }
    p {
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.6);
      height: 70px;
      line-height: 40px;
      box-sizing: border-box;
      padding: 2px 0 0 0;
      font-size: 18px;
      color: #fff;
      font-family: Verdana;
      margin: 0;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      text-align: center;
      span {
        width: 85%;
        display: block;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
    a {
      display: block;
      width: 100%;
      height: 100%;
    }
  }
  .swiper-pagination {
    bottom: 6px;
    box-sizing: border-box;
    padding: 0 5px;
    text-align: center;
    z-index: 1;
    right: 0;
    left: 0;
    width: auto;
    /deep/ .swiper-pagination-bullet {
      width: 12px !important;
      height: 12px !important;
      opacity: 1;
      background: #d9d9d9;
      &:hover {
        opacity: 1;
      }
      &.swiper-pagination-bullet-active {
        background: #FFD9D9;
      }
    }
  }
}
.swiper-whole {
  width: 100%;
  height: 750px;
  .swiper-slide {
    display: block;
    p {
      font-size: 24px;
      height: 60px;
      line-height: 60px;
      padding: 0 20px;
    }
  }
  .swiper-pagination {
    bottom: 20px;
  }
}
</style>